/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-08 17:53:42
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Card, Layout, TextContainer, Heading } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import remove from 'src/assets/images/dashboard/remove.png';

type Props = {
  onCloseDismissNotice: () => void
};

type ComposedProps = Props & WithI18nProps;
class AfterFeedback extends Component<ComposedProps> {
  timeoutId: any = 0;

  componentDidMount() {
    const { onCloseDismissNotice } = this.props;
    this.timeoutId = setTimeout(() => onCloseDismissNotice(), 5000);
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  render() {
    const { i18n } = this.props;
    return (
      <Card>
        <Card.Section>
          <Layout>
            <Layout.Section secondary>
              <TextContainer>
                <Heading>
                  {i18n.translate('AdminHTML.Dashboard.BlockCanDismiss.afterFeedback_Heading')}
                </Heading>
                <p>
                  {i18n.translate('AdminHTML.Dashboard.BlockCanDismiss.afterFeedback_Paragraph')}
                </p>
              </TextContainer>
            </Layout.Section>
            <Layout.Section>
              <div className="BC-Illustration-Image__Dashboard BC-Remove-Image__Dashboard">
                <img src={remove} alt="" />
              </div>
            </Layout.Section>
          </Layout>
        </Card.Section>
      </Card>
    );
  }
}

export default withI18n()(AfterFeedback);
